// extracted by mini-css-extract-plugin
export default {"header":"BillsReportProviderItem_header__Sc-8f","header__status":"BillsReportProviderItem_header__status__dIqlD"};